import {
  Alert,
  Box,
  Button,
  Modal,
  SpaceBetween,
} from "@cloudscape-design/components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { LAST_VISIT_URL } from "@/utils/const";

const ReSignIn: React.FC = () => {
  const auth = useAuth();
  const { t } = useTranslation();

  const publicUrl = process.env.PUBLIC_URL ?? "";
  const basePath = publicUrl.endsWith("/") ? publicUrl.slice(0, -1) : publicUrl;
  const rawPath = window.location.pathname;
  const appPath =
    basePath && rawPath.startsWith(basePath)
      ? rawPath.slice(basePath.length) || "/"
      : rawPath;
  const appLocation = `${appPath}${window.location.search}${window.location.hash}`;

  return (
    <div className="re-sign-in">
      <Modal
        className="re-sign-in-modal"
        visible={true}
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                onClick={() => {
                  localStorage.setItem(LAST_VISIT_URL, appLocation);
                  auth.signinRedirect();
                }}
                variant="primary"
              >
                {t("button.reload")}
              </Button>
            </SpaceBetween>
          </Box>
        }
        header={t("header.reSignIn")}
      >
        <div className="mt-10">
          <Alert statusIconAriaLabel="Error" type="warning">
            {t("header.reSignInDesc")}
          </Alert>
        </div>
      </Modal>
    </div>
  );
};

export default ReSignIn;
